var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleInfoRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_5659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95116 0.666626C3.90064 0.666626 0.617828 3.94944 0.617828 7.99996C0.617828 12.0505 3.90064 15.3333 7.95116 15.3333C12.0017 15.3333 15.2845 12.0505 15.2845 7.99996C15.2845 3.94944 12.0017 0.666626 7.95116 0.666626ZM7.95116 13.9583C4.66548 13.9583 1.99283 11.2853 1.99283 7.99996C1.99283 4.71457 4.66548 2.04163 7.95116 2.04163C11.2368 2.04163 13.9095 4.71457 13.9095 7.99996C13.9095 11.2853 11.2368 13.9583 7.95116 13.9583ZM9.09699 10.2916H8.63866V7.77079C8.63866 7.39267 8.33215 7.08329 7.95116 7.08329H7.03449C6.65637 7.08329 6.34699 7.39267 6.34699 7.77079C6.34699 8.14892 6.65637 8.45829 7.03449 8.45829H7.26366V10.2916H6.80533C6.4272 10.2916 6.11783 10.601 6.11783 10.9791C6.11783 11.3573 6.4272 11.6666 6.80533 11.6666H9.09699C9.47655 11.6666 9.78449 11.3587 9.78449 10.9791C9.78449 10.5996 9.47798 10.2916 9.09699 10.2916ZM7.95116 6.16663C8.45733 6.16663 8.86783 5.75613 8.86783 5.24996C8.86783 4.74379 8.45733 4.33329 7.95116 4.33329C7.44499 4.33329 7.03449 4.74293 7.03449 5.24996C7.03449 5.75699 7.44413 6.16663 7.95116 6.16663Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_5659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 14.6667,
    fill: "white",
    transform: "translate(0.617828 0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInfoRegular);
export default __webpack_public_path__ + "static/media/circle-info-regular.30825ce9e452500f330d44d23426ba97.svg";
export { ForwardRef as ReactComponent };